import { render, staticRenderFns } from "./Quirofano.vue?vue&type=template&id=395b5a08&"
import script from "./Quirofano.vue?vue&type=script&lang=js&"
export * from "./Quirofano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports